const { construct } = require('./construct')

// Shape rows from `productSKU.getProductRowsForSkus` into product docs, so a PG
// read answers in the same shape as the pouch read it stands in for.
//
// Running the rows through the same `construct` the pouch adapter uses is what
// keeps the two interchangeable: `code` comes from the id the same way, and the
// optional-field rules stay in one place. Notably `unitPrice` is left off —
// couch computes it from a dated `prices` array that the PG sync stores as
// history rows rather than a column, so there is nothing here to compute it
// from. Consumers reading it default to 0 until #25360 lands the missing
// product fields.
//
// Rows without any name are dropped rather than constructed: `construct`
// rejects them, and a caller that gets nothing back can still fall back to the
// identifier it asked with.
const isNumeric = value => value !== null && value !== undefined && Number.isFinite(Number(value))

const rowToRawProduct = row => ({
  _id: `product:${row.old_sku_id}`,
  name: row.name || '',
  fullName: row.display_name || row.name || '',
  ...(isNumeric(row.volume) ? { unitVolume: Number(row.volume) } : {}),
  ...(isNumeric(row.unit_of_issue) ? { unitOfIssue: Number(row.unit_of_issue) } : {}),
  ...(row.packaging_type ? { basicUnit: row.packaging_type } : {}),
  ...(row.manufacturer ? { manufacturer: row.manufacturer } : {})
})

const pgRowsToProducts = (rows = [], { now } = {}) =>
  rows
    .filter(row => row && row.old_sku_id && (row.display_name || row.name))
    .map(row => construct(rowToRawProduct(row), now ? { now } : {}))

module.exports = { pgRowsToProducts }
